// extracted by mini-css-extract-plugin
module.exports = {"container":"WhaleTales_container__2F2HW"};